import { render, staticRenderFns } from "./DiseaseActiveList.vue?vue&type=template&id=534634f8&scoped=true&"
import script from "./DiseaseActiveList.vue?vue&type=script&lang=js&"
export * from "./DiseaseActiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534634f8",
  null
  
)

export default component.exports